/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const TemplateCategoryListDocument = gql`
    query TemplateCategoryList {
  commonTemplateCategoryList {
    id
    title
  }
}
    `;

/**
 * __useTemplateCategoryListQuery__
 *
 * To run a query within a React component, call `useTemplateCategoryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateCategoryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateCategoryListQuery({
 *   variables: {
 *   },
 * });
 */
export function useTemplateCategoryListQuery(baseOptions?: Apollo.QueryHookOptions<TemplateCategoryListQuery, TemplateCategoryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplateCategoryListQuery, TemplateCategoryListQueryVariables>(TemplateCategoryListDocument, options);
      }
export function useTemplateCategoryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplateCategoryListQuery, TemplateCategoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplateCategoryListQuery, TemplateCategoryListQueryVariables>(TemplateCategoryListDocument, options);
        }
// @ts-ignore
export function useTemplateCategoryListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TemplateCategoryListQuery, TemplateCategoryListQueryVariables>): Apollo.UseSuspenseQueryResult<TemplateCategoryListQuery, TemplateCategoryListQueryVariables>;
export function useTemplateCategoryListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TemplateCategoryListQuery, TemplateCategoryListQueryVariables>): Apollo.UseSuspenseQueryResult<TemplateCategoryListQuery | undefined, TemplateCategoryListQueryVariables>;
export function useTemplateCategoryListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TemplateCategoryListQuery, TemplateCategoryListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TemplateCategoryListQuery, TemplateCategoryListQueryVariables>(TemplateCategoryListDocument, options);
        }
export type TemplateCategoryListQueryHookResult = ReturnType<typeof useTemplateCategoryListQuery>;
export type TemplateCategoryListLazyQueryHookResult = ReturnType<typeof useTemplateCategoryListLazyQuery>;
export type TemplateCategoryListSuspenseQueryHookResult = ReturnType<typeof useTemplateCategoryListSuspenseQuery>;
export type TemplateCategoryListQueryResult = Apollo.QueryResult<TemplateCategoryListQuery, TemplateCategoryListQueryVariables>;
export const TemplateCategoryShowDocument = gql`
    query TemplateCategoryShow($templateCategory: Int!) {
  templateCategoryShow(templateCategory: $templateCategory) {
    id
    title
    position
    parent
    templates {
      id
      name
      position
      isCommon
    }
  }
}
    `;

/**
 * __useTemplateCategoryShowQuery__
 *
 * To run a query within a React component, call `useTemplateCategoryShowQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateCategoryShowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateCategoryShowQuery({
 *   variables: {
 *      templateCategory: // value for 'templateCategory'
 *   },
 * });
 */
export function useTemplateCategoryShowQuery(baseOptions: Apollo.QueryHookOptions<TemplateCategoryShowQuery, TemplateCategoryShowQueryVariables> & ({ variables: TemplateCategoryShowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplateCategoryShowQuery, TemplateCategoryShowQueryVariables>(TemplateCategoryShowDocument, options);
      }
export function useTemplateCategoryShowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplateCategoryShowQuery, TemplateCategoryShowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplateCategoryShowQuery, TemplateCategoryShowQueryVariables>(TemplateCategoryShowDocument, options);
        }
// @ts-ignore
export function useTemplateCategoryShowSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TemplateCategoryShowQuery, TemplateCategoryShowQueryVariables>): Apollo.UseSuspenseQueryResult<TemplateCategoryShowQuery, TemplateCategoryShowQueryVariables>;
export function useTemplateCategoryShowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TemplateCategoryShowQuery, TemplateCategoryShowQueryVariables>): Apollo.UseSuspenseQueryResult<TemplateCategoryShowQuery | undefined, TemplateCategoryShowQueryVariables>;
export function useTemplateCategoryShowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TemplateCategoryShowQuery, TemplateCategoryShowQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TemplateCategoryShowQuery, TemplateCategoryShowQueryVariables>(TemplateCategoryShowDocument, options);
        }
export type TemplateCategoryShowQueryHookResult = ReturnType<typeof useTemplateCategoryShowQuery>;
export type TemplateCategoryShowLazyQueryHookResult = ReturnType<typeof useTemplateCategoryShowLazyQuery>;
export type TemplateCategoryShowSuspenseQueryHookResult = ReturnType<typeof useTemplateCategoryShowSuspenseQuery>;
export type TemplateCategoryShowQueryResult = Apollo.QueryResult<TemplateCategoryShowQuery, TemplateCategoryShowQueryVariables>;
export const TemplateCategoryNewDocument = gql`
    mutation TemplateCategoryNew($title: String!, $position: Int!) {
  templateCategoryNew(title: $title, position: $position) {
    id
    title
    parent
    position
  }
}
    `;
export type TemplateCategoryNewMutationFn = Apollo.MutationFunction<TemplateCategoryNewMutation, TemplateCategoryNewMutationVariables>;

/**
 * __useTemplateCategoryNewMutation__
 *
 * To run a mutation, you first call `useTemplateCategoryNewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTemplateCategoryNewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [templateCategoryNewMutation, { data, loading, error }] = useTemplateCategoryNewMutation({
 *   variables: {
 *      title: // value for 'title'
 *      position: // value for 'position'
 *   },
 * });
 */
export function useTemplateCategoryNewMutation(baseOptions?: Apollo.MutationHookOptions<TemplateCategoryNewMutation, TemplateCategoryNewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TemplateCategoryNewMutation, TemplateCategoryNewMutationVariables>(TemplateCategoryNewDocument, options);
      }
export type TemplateCategoryNewMutationHookResult = ReturnType<typeof useTemplateCategoryNewMutation>;
export type TemplateCategoryNewMutationResult = Apollo.MutationResult<TemplateCategoryNewMutation>;
export type TemplateCategoryNewMutationOptions = Apollo.BaseMutationOptions<TemplateCategoryNewMutation, TemplateCategoryNewMutationVariables>;
export const TemplateCategoryEditDocument = gql`
    mutation TemplateCategoryEdit($templateCategory: Int!, $title: String!, $position: Int!) {
  templateCategoryEdit(
    templateCategory: $templateCategory
    title: $title
    position: $position
  ) {
    id
    title
    parent
  }
}
    `;
export type TemplateCategoryEditMutationFn = Apollo.MutationFunction<TemplateCategoryEditMutation, TemplateCategoryEditMutationVariables>;

/**
 * __useTemplateCategoryEditMutation__
 *
 * To run a mutation, you first call `useTemplateCategoryEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTemplateCategoryEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [templateCategoryEditMutation, { data, loading, error }] = useTemplateCategoryEditMutation({
 *   variables: {
 *      templateCategory: // value for 'templateCategory'
 *      title: // value for 'title'
 *      position: // value for 'position'
 *   },
 * });
 */
export function useTemplateCategoryEditMutation(baseOptions?: Apollo.MutationHookOptions<TemplateCategoryEditMutation, TemplateCategoryEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TemplateCategoryEditMutation, TemplateCategoryEditMutationVariables>(TemplateCategoryEditDocument, options);
      }
export type TemplateCategoryEditMutationHookResult = ReturnType<typeof useTemplateCategoryEditMutation>;
export type TemplateCategoryEditMutationResult = Apollo.MutationResult<TemplateCategoryEditMutation>;
export type TemplateCategoryEditMutationOptions = Apollo.BaseMutationOptions<TemplateCategoryEditMutation, TemplateCategoryEditMutationVariables>;
export const TemplateCategoryDeleteDocument = gql`
    mutation TemplateCategoryDelete($templateCategory: Int!) {
  templateCategoryDelete(templateCategory: $templateCategory)
}
    `;
export type TemplateCategoryDeleteMutationFn = Apollo.MutationFunction<TemplateCategoryDeleteMutation, TemplateCategoryDeleteMutationVariables>;

/**
 * __useTemplateCategoryDeleteMutation__
 *
 * To run a mutation, you first call `useTemplateCategoryDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTemplateCategoryDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [templateCategoryDeleteMutation, { data, loading, error }] = useTemplateCategoryDeleteMutation({
 *   variables: {
 *      templateCategory: // value for 'templateCategory'
 *   },
 * });
 */
export function useTemplateCategoryDeleteMutation(baseOptions?: Apollo.MutationHookOptions<TemplateCategoryDeleteMutation, TemplateCategoryDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TemplateCategoryDeleteMutation, TemplateCategoryDeleteMutationVariables>(TemplateCategoryDeleteDocument, options);
      }
export type TemplateCategoryDeleteMutationHookResult = ReturnType<typeof useTemplateCategoryDeleteMutation>;
export type TemplateCategoryDeleteMutationResult = Apollo.MutationResult<TemplateCategoryDeleteMutation>;
export type TemplateCategoryDeleteMutationOptions = Apollo.BaseMutationOptions<TemplateCategoryDeleteMutation, TemplateCategoryDeleteMutationVariables>;
export const UpdatePositionTemplatesDocument = gql`
    mutation UpdatePositionTemplates($templatesPriority: [GraphTemplatePriorityInput!]!) {
  updatePositionTemplates(templatesPriority: $templatesPriority) {
    id
  }
}
    `;
export type UpdatePositionTemplatesMutationFn = Apollo.MutationFunction<UpdatePositionTemplatesMutation, UpdatePositionTemplatesMutationVariables>;

/**
 * __useUpdatePositionTemplatesMutation__
 *
 * To run a mutation, you first call `useUpdatePositionTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePositionTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePositionTemplatesMutation, { data, loading, error }] = useUpdatePositionTemplatesMutation({
 *   variables: {
 *      templatesPriority: // value for 'templatesPriority'
 *   },
 * });
 */
export function useUpdatePositionTemplatesMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePositionTemplatesMutation, UpdatePositionTemplatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePositionTemplatesMutation, UpdatePositionTemplatesMutationVariables>(UpdatePositionTemplatesDocument, options);
      }
export type UpdatePositionTemplatesMutationHookResult = ReturnType<typeof useUpdatePositionTemplatesMutation>;
export type UpdatePositionTemplatesMutationResult = Apollo.MutationResult<UpdatePositionTemplatesMutation>;
export type UpdatePositionTemplatesMutationOptions = Apollo.BaseMutationOptions<UpdatePositionTemplatesMutation, UpdatePositionTemplatesMutationVariables>;
export type TemplateCategoryListQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type TemplateCategoryListQuery = { __typename?: 'Query', commonTemplateCategoryList: Array<{ __typename?: 'GraphTemplateCategory', id?: number | null, title?: string | null }> };

export type TemplateCategoryShowQueryVariables = Types.Exact<{
  templateCategory: Types.Scalars['Int']['input'];
}>;


export type TemplateCategoryShowQuery = { __typename?: 'Query', templateCategoryShow: { __typename?: 'GraphTemplateCategory', id?: number | null, title?: string | null, position?: number | null, parent?: number | null, templates: Array<{ __typename?: 'GraphTemplate', id?: number | null, name?: string | null, position?: number | null, isCommon?: boolean | null }> } };

export type TemplateCategoryNewMutationVariables = Types.Exact<{
  title: Types.Scalars['String']['input'];
  position: Types.Scalars['Int']['input'];
}>;


export type TemplateCategoryNewMutation = { __typename?: 'Mutation', templateCategoryNew: { __typename?: 'GraphTemplateCategory', id?: number | null, title?: string | null, parent?: number | null, position?: number | null } };

export type TemplateCategoryEditMutationVariables = Types.Exact<{
  templateCategory: Types.Scalars['Int']['input'];
  title: Types.Scalars['String']['input'];
  position: Types.Scalars['Int']['input'];
}>;


export type TemplateCategoryEditMutation = { __typename?: 'Mutation', templateCategoryEdit: { __typename?: 'GraphTemplateCategory', id?: number | null, title?: string | null, parent?: number | null } };

export type TemplateCategoryDeleteMutationVariables = Types.Exact<{
  templateCategory: Types.Scalars['Int']['input'];
}>;


export type TemplateCategoryDeleteMutation = { __typename?: 'Mutation', templateCategoryDelete: boolean };

export type UpdatePositionTemplatesMutationVariables = Types.Exact<{
  templatesPriority: Array<Types.GraphTemplatePriorityInput> | Types.GraphTemplatePriorityInput;
}>;


export type UpdatePositionTemplatesMutation = { __typename?: 'Mutation', updatePositionTemplates: Array<{ __typename?: 'GraphTemplate', id?: number | null }> };
